import React from 'react';
import { Helmet } from 'react-helmet';
import {
  FaWordpress,
  FaPalette,
  FaMobileAlt,
  FaSearch,
  FaLock,
} from 'react-icons/fa';
import SEO from '../../components/SEO';


const WordPressWebsiteDesign = () => {
  return (
      <>
    <SEO title="Wordpress Website Design" />
    <div className="py-12 px-4 max-w-7xl mx-auto text-gray-800">
      <Helmet>
        <title>WordPress Website Design | AKHSoft</title>
        <meta
          name="description"
          content="Professional WordPress website design services by AKHSoft – custom themes, responsive layouts, SEO-optimized, and secure. Perfect for businesses, blogs, and portfolios."
        />
      </Helmet>

      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-[#ff9b00] mb-4">
          WordPress Website Design
        </h1>
        <p className="text-lg max-w-3xl mx-auto text-gray-600">
          Get a professional, scalable, and visually appealing WordPress website designed to reflect your brand and drive results. Whether it's a business site, blog, or portfolio — AKHSoft crafts websites that convert.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-10">
        {/* Feature 1 */}
        <div className="flex items-start space-x-5">
          <FaWordpress className="text-[#ff9b00] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#ff9b00]">
              Custom WordPress Development
            </h3>
            <p className="text-gray-700">
              Tailor-made themes and functionalities that align perfectly with your brand's needs and objectives.
            </p>
          </div>
        </div>

        {/* Feature 2 */}
        <div className="flex items-start space-x-5">
          <FaPalette className="text-[#ff9b00] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#ff9b00]">
              Beautiful, Modern Designs
            </h3>
            <p className="text-gray-700">
              Visually captivating and user-friendly interfaces that enhance your brand’s image and improve engagement.
            </p>
          </div>
        </div>

        {/* Feature 3 */}
        <div className="flex items-start space-x-5">
          <FaMobileAlt className="text-[#ff9b00] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#ff9b00]">
              Fully Responsive Layouts
            </h3>
            <p className="text-gray-700">
              Optimized for desktops, tablets, and smartphones — your site looks stunning on every screen size.
            </p>
          </div>
        </div>

        {/* Feature 4 */}
        <div className="flex items-start space-x-5">
          <FaSearch className="text-[#ff9b00] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#ff9b00]">
              SEO Optimized Structure
            </h3>
            <p className="text-gray-700">
              Get discovered on search engines with clean code, fast performance, and SEO-ready structure.
            </p>
          </div>
        </div>

        {/* Feature 5 */}
        <div className="flex items-start space-x-5">
          <FaLock className="text-[#ff9b00] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#ff9b00]">
              Secure and Scalable
            </h3>
            <p className="text-gray-700">
              Built with security best practices and scalable architecture to grow with your business.
            </p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="mt-16 text-center">
        <h3 className="text-2xl font-semibold text-[#ff9b00] mb-4">
          Let’s Build Your Dream Website!
        </h3>
        <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
          From planning to launch, AKHSoft delivers a complete WordPress solution tailored to your goals. Start your online journey with confidence.
        </p>
        <a
          href="/contact"
          className="inline-block bg-[#ff9b00] text-white py-3 px-6 rounded-lg hover:bg-orange-600 transition"
        >
          Get in Touch
        </a>
      </div>
    </div>
    </>
  );
};

export default WordPressWebsiteDesign;
